import * as yup from 'yup'

// const validateSwiftCodeAndBankAccountNumber = (
//   value: string | null | undefined,
//   valueType: 'swiftCode' | 'bankAccountNumber'
// ): boolean => {
//   const validateValue = value ?? ''

//   if (valueType === 'swiftCode') {
//     const isValidSwiftCode = /^[A-Z0-9]{8,11}$/.test(validateValue)

//     return isValidSwiftCode || validateValue === ''
//   } else {
//     return validateValue === ''
//   }
// }

export const validateBankDataOrAmazonGiftEmailIsFilled = (value: any) => {
  if (!value) return false

  const {
    swiftCode,
    bankAccountNumber,
    internationalBankBranch,
    amazonGiftCardEmail,
  } = value

  const internationalBankDataFilled =
    swiftCode &&
    swiftCode.trim() !== '' &&
    bankAccountNumber &&
    bankAccountNumber.trim() !== '' &&
    internationalBankBranch &&
    internationalBankBranch.trim() !== ''

  const amazonGiftCardEmailFilled =
    amazonGiftCardEmail && amazonGiftCardEmail.trim() !== ''

  return !!(internationalBankDataFilled || amazonGiftCardEmailFilled)
}

export const internationalBankDataSchema = yup.object({
  swiftCode: yup.string().optional(),
  bankAccountNumber: yup.string().optional(),
  internationalBankBranch: yup.string().max(50, 'BANK_BRANCH_TOO_LONG'),
  amazonGiftCardEmail: yup.string(),
})
